export const getFlipStatus = async (token) => {
    try {
        const response = await fetch(`https://blue-moon-app-backend.vercel.app/flip`, {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${token}`,
            },
        });
        if (response.ok) {
            const data = await response.json();
            const flipStatus = data.flipStatus;
            return flipStatus;
        } else {
            throw new Error('Failed to fetch user data');
        }
    } catch (error) {
        console.error('Error:', error);
    }
};